import page from './index';

export default { path: '/home/transactionStatistics', component: page };
